import { Action, State, StateContext } from '@ngxs/store';

import { Gift } from './gift.model';
import * as GiftActions from './gift.actions';

@State<Gift>({
  name: 'gift',
  defaults: new Gift()
})
export class GiftState {
  @Action(GiftActions.SetGiftID)
  setGiftID(
    { getState, setState }: StateContext<Gift>,
    { payload }: GiftActions.SetGiftID
  ) {
    const state = getState();
    setState({ ...state, id: payload });
  }

  @Action(GiftActions.SetGiftExtra)
  setGiftExtra(
    { getState, setState }: StateContext<Gift>,
    { payload }: GiftActions.SetGiftExtra
  ) {
    const state = getState();
    setState({ ...state, extra: payload });
  }

  @Action(GiftActions.SetGiftCompleted)
  setGiftCompleted(
    { getState, setState }: StateContext<Gift>,
    { payload }: GiftActions.SetGiftCompleted
  ) {
    const state = getState();
    setState({ ...state, completed: payload });
  }
}
